import axios from 'axios';
import toastr from 'toastr';
import Loading from './components/loading/loading';


toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  preventDuplicates: true,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut"
};

// Usar a variável de ambiente em produção ou o servidor local para os testes
const API_URL = process.env.REACT_APP_URL || 'http://100.113.102.83:3001/';

const api = axios.create({
  baseURL: API_URL
});

// Contador para gerenciar múltiplas requisições simultâneas
let activeRequests = 0;

const toggleLoading = (show) => {
  if (show) {
    if (activeRequests === 0) {
      Loading.show('Carregando...');
    }
    activeRequests++;
  } else {
    activeRequests--;
    if (activeRequests <= 0) {
      activeRequests = 0;
      Loading.hide();
    }
  }
};

// Interceptores para automação de Loading e Toastr de Erro
api.interceptors.request.use((config) => {
  if (!config.hideLoading) toggleLoading(true);
  return config;
}, (error) => {
  toggleLoading(false);
  return Promise.reject(error);
});

api.interceptors.response.use(
  (response) => {
    if (!response.config.hideLoading) toggleLoading(false);
    return response;
  },
  (error) => {
    if (!error.config?.hideLoading) toggleLoading(false);
    // Substitui o alert por toastr automaticamente em caso de erro de API
    const msg = error.response?.data?.error || error.response?.data?.message || 'Erro na comunicação com o servidor.';
    toastr.remove();
    toastr.error(msg, 'Erro');
    return Promise.reject(error);
  }
);

const handleResponse = (promise, successMsg) => promise.then(res => {
  if (successMsg) toastr.success(successMsg);
  return res.data;
});

export const getEventos = () => api.get('/eventos', { hideLoading: true }).then(res => res.data);
export const getEvento = (slug) => api.get(`/eventos/${slug}`, { hideLoading: true }).then(res => res.data);
export const createEvento = (data) => handleResponse(api.post('/eventos', data), 'Evento criado com sucesso!');
export const updateEvento = (id, data) => handleResponse(api.put(`/eventos/${id}`, data), 'Evento atualizado!');

export const createLote = (eventoId, data) => api.post(`/eventos/${eventoId}/lotes`, data).then(res => res.data);
export const updateLote = (id, data) => api.put(`/eventos/lotes/${id}`, data).then(res => res.data);
export const deleteLote = (id) => api.delete(`/eventos/lotes/${id}`).then(res => res.data);

export const createInscricao = (data) => api.post('/eventos/inscricao', data).then(res => res.data);
export const createInscricaoInterna = (data) => api.post('/eventos/inscricoes/criar-interna', data).then(res => res.data);
export const getInscricoes = (eventoId) => api.get(`/eventos/${eventoId}/inscricoes`).then(res => res.data);
export const enviarCodigoVerificacao = (email) => api.post('/eventos/inscricoes/enviar-codigo', { email }).then(res => res.data);
export const verificarCodigoVerificacao = (email, codigo) => api.post('/eventos/inscricoes/verificar-codigo', { email, codigo }).then(res => res.data);
export const cancelarInscricao = (id, reembolsar) => api.post(`/eventos/inscricoes/${id}/cancelar`, { reembolsar }).then(res => res.data);

// Cupons, Credenciamento e E-mail
export const getCupons = () => api.get('/eventos/cupons/listar').then(res => res.data);
export const createCupom = (data) => api.post('/eventos/cupons/criar', data).then(res => res.data);
export const updateCupom = (id, data) => api.put(`/eventos/cupons/${id}`, data).then(res => res.data);
export const deleteCupom = (id) => api.delete(`/eventos/cupons/${id}`).then(res => res.data);
export const validarCupom = (codigo, preco, eventoId) => api.post('/eventos/cupons/validar', { codigo, preco, evento_id: eventoId }).then(res => res.data);
export const confirmarInscricaoManual = (id) => api.post(`/eventos/inscricoes/${id}/confirmar`).then(res => res.data);
export const reenviarEmailConfirmacao = (id) => api.post(`/eventos/inscricoes/${id}/reenviar-email`).then(res => res.data);
export const validarTicket = (ticketCode, cpf, eventoId) => api.post('/eventos/inscricoes/validar-ticket', { ticket_code: ticketCode, cpf, evento_id: eventoId }).then(res => res.data);
export const buscarTicket = (ticketCode, cpf, eventoId) => api.post('/eventos/inscricoes/buscar-ticket', { ticket_code: ticketCode, cpf, evento_id: eventoId }).then(res => res.data);
export const confirmarPresenca = (id) => api.post(`/eventos/inscricoes/${id}/confirmar-presenca`).then(res => res.data);
export const getPagamentoConfig = () => api.get('/eventos/pagamento/config').then(res => res.data);

// Auth Admin
export const adminLogin = (USUARIO, SENHA) => api.post('/auth/login', { USUARIO, SENHA }, { hideLoading: true }).then(res => res.data);
export const alterarSenhaAdmin = (ID_USUARIO, SENHA) => api.put('/auth/alterar-senha', { ID_USUARIO, SENHA }).then(res => res.data);
export const listarUsuariosAdmin = () => api.get('/auth/usuarios').then(res => res.data);
export const criarUsuarioAdmin = (data) => api.post('/auth/usuarios', data).then(res => res.data);
export const atualizarUsuarioAdmin = (id, data) => api.put(`/auth/usuarios/${id}`, data).then(res => res.data);
export const excluirUsuarioAdmin = (id) => api.delete(`/auth/usuarios/${id}`).then(res => res.data);

export default api;
